import { useCallback } from 'react';
import { useContext } from '../ContextProvider/context.esm.js';

function useSorting() {
  var _variables$get$sort;

  var _useContext = useContext(),
      _useContext$search = _useContext.search,
      search = _useContext$search.search,
      variables = _useContext$search.variables;

  var setSorting = useCallback(function (order, runSearch) {
    if (runSearch === void 0) {
      runSearch = true;
    }

    variables.set({
      sort: order
    });

    if (runSearch) {
      search();
    }
  }, [variables, search]);
  return {
    sorting: (_variables$get$sort = variables.get().sort) != null ? _variables$get$sort : '',
    setSorting: setSorting
  };
}

export default useSorting;
//# sourceMappingURL=index.esm.js.map
